import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { QuestionFeedbackCreateInput } from '../generated/globalTypes';
import { createQuestionFeedbackMutation, createQuestionFeedbackMutationVariables } from '../generated/createQuestionFeedbackMutation';
import { questionFeedbackFieldsFragment } from '../models/QuestionFeedback';

/**
 * Get a callback to create a QuestionFeedback in the store.
 */
export function useCreateQuestionFeedbackCallback(): [(model: QuestionFeedbackCreateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<createQuestionFeedbackMutation, createQuestionFeedbackMutationVariables>(
        gql`
            mutation createQuestionFeedbackMutation ($model: QuestionFeedbackCreateInput!) {
                createQuestionFeedback(model: $model) {
                    ...questionFeedbackFields
                }
            }

            ${questionFeedbackFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (model: QuestionFeedbackCreateInput) => {
        const result = await mutationAction({ variables: { model: model } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
